import { cn } from 'utils/cn';

import { CalendarTab } from '../calendar-state';

const TABS: Array<{ value: CalendarTab; label: string }> = [
    { value: 'calendar', label: 'Calendar' },
    { value: 'meetingMinutes', label: 'Meeting Minutes' },
];

// Underline text tabs under the page title, per the BFO meeting-minutes design concepts —
// except the active rule: the concepts show aqua, but it uses the cocoa `accent` token to
// match the client page's tabs (ui/tabs.tsx). Inactive tabs are faint regular text.
export const CalendarTabs = ({
    activeTab,
    onTabChange,
}: {
    activeTab: CalendarTab;
    onTabChange: (tab: CalendarTab) => void;
}) => (
    <div className="border-cocoa-100 flex gap-6 border-b">
        {TABS.map(({ value, label }) => (
            <button
                key={value}
                type="button"
                className={cn(
                    'cursor-pointer border-b-2 pb-2.5 text-sm',
                    value === activeTab
                        ? 'text-cocoa-1000 border-accent font-medium'
                        : 'text-cocoa-500 hover:text-cocoa-800 border-transparent',
                )}
                onClick={() => onTabChange(value)}
            >
                {label}
            </button>
        ))}
    </div>
);
